import { useState, useEffect } from "react";

const useTrackCommentForm = (initialFormValues, callback, validate) => {
  const [inputs, setInputs] = useState(initialFormValues);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (Object.keys(errors).length === 0 && isSubmitting) {
      callback();
    }
  }, [errors]);

  const handleInputChange = (event) => {
    event.persist();
    setInputs((inputs) => ({ ...inputs, [event.target.name]: event.target.value }));
  };
  const insertLinkTag = () => {
    const selected = window.getSelection().toString();
    const link = selected.startsWith('http') ? `<a href="${selected.trim()}" target="_blank">` + selected + `</a>` : `<a href="PASTE_URL_HERE" target="_blank">` + selected + `</a>`;
    inputs.trackComment ? (inputs.trackComment = inputs.trackComment.replace(selected, link)) : (inputs.trackComment = link);
    inputs.message ? (inputs.message = inputs.message.replace(selected, link)) : (inputs.message = link);
    setInputs((inputs) => ({ ...inputs }));
  };
  const imageTag = `<img src="ADD_YOUR_URL_HERE" class="img-responsive" border="0" />`;
  const insertImageTag = () => {
    inputs.trackComment ? (inputs.trackComment += ` ${imageTag}`) : (inputs.trackComment += imageTag);
    inputs.message ? (inputs.message += ` ${imageTag}`) : (inputs.message += imageTag);
    setInputs((inputs) => ({ ...inputs }));
  };
  const clearForm = () => {
    setInputs(initialFormValues);
  };

  const handleSubmit = (event) => {
    if (event) event.preventDefault();
    setErrors(validate(inputs));
    setIsSubmitting(true);
  };

  return {
    handleInputChange,
    handleSubmit,
    insertLinkTag,
    insertImageTag,
    inputs,
    clearForm,
    errors,
  };
};

export default useTrackCommentForm;
